import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { KonfirmasiHapusComponent } from 'src/app/shared/state/konfirmasi-hapus/konfirmasi-hapus.component';
import { UserLapanganAddComponent } from 'src/app/user-lapangan/user-lapangan-add/user-lapangan-add.component';
import { NavigationExtras, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormBuilder,FormGroup } from '@angular/forms';
import { DetailHasilSurveyComponent } from '../../surveyor-report/detail-hasil-survey/detail-hasil-survey.component';
import { DetailReportPerformanceComponent } from '../detail-report-performance/detail-report-performance.component';


@Component({
  selector: 'app-report-performance',
  templateUrl: './report-performance.component.html',
  styleUrls: ['./report-performance.component.css']
})
export class ReportPerformanceComponent implements OnInit {


  page: any = 1;

  fractionSize;
  ionicForm: FormGroup;
  isSubmitted = false;
  nn: any = '';
  form: any = '';
  

  user: any;
  token: any;
  hasil: any;
  load: boolean = false;

  leadn: any = {};
  lnores: any;
  aa: any;

  opsi: boolean = false;
  totalCekData: any;
  pageInfo: any = {};
  pageNation: any;

  viewType: any;

  filter: any = '';
  filterr: any = '';

  resAr: any;
  add: any = {};

  leadnHapus: any = {};

  kinfo: any = {};
  dataInfo: any;

  isIndeterminate:boolean;
  masterCheck:boolean;
  checkBoxList:any;

  cabang: any = '';
  tenor: any = '';
  agunan: any = '';
  plafon: any = '';
  kolektor: any = '';

  baseUrl: any = '';
  usertoken: any = '';

  users: any;
  parent: any = {};
  children: any = {};
  action: any;

  act1: any;
  act2: any;
  act3: any;

  dateRange: any = '';
  filterDaterange: any = [];

  tampilDateRange: boolean = false;
  resetInput: boolean = false;

  pending_survey: any = '0';
  finish_survey: any = '0';
  startDate: any = '';
  endDate: any = '';

  userX : any = '';
  summary: any = {};

  constructor(
    public util: UtilService,
    public api: ApiService,
    public modalController: ModalController,
    public router: Router,
    public http: HttpClient,
    public formBuilder: FormBuilder,

  ) {
    this.baseUrl = environment.restURL.baseUrl;
    this.usertoken = localStorage.getItem('usertoken') || 'null';
  }

  submitForm(){
    console.log('FORM',this.ionicForm.value);
    this.nn = this.ionicForm.value.name;
    this.isSubmitted = true;
    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values!')
      return false;
    } else {
      console.log('Keyboard',this.nn);
      this.res();
    }
  }

  ngOnInit() {
    this.ionicForm = this.formBuilder.group({
      name: ['']
    });
  }


  ionViewWillEnter() {
    this.page = 1;
    this.res();
  }
  
  handleSelection(selectedValue: string, model: any) {
    if (model == 'cabang') {
      this.cabang = selectedValue;
    } else if (model == 'tenor') {
      this.tenor = selectedValue;
    } else if (model == 'agunan') {
      this.agunan = selectedValue;
    } else if (model == 'plafon') {
      this.plafon = selectedValue;
    } else if (model == 'kolektor') {
      this.kolektor = selectedValue;
    } else if (model == 'dateRange') {
      this.dateRange = selectedValue;
    }
    this.res()
  }

  daterangeFilter(selectedValue: string, model: any){
    console.log('selectedValue',selectedValue);
    console.log('dateRange',this.dateRange);
    const [startDateString, endDateString] = selectedValue.split(' - ');
    const dateArray = [startDateString, endDateString];
    this.filterDaterange = dateArray;
    console.log('filterDaterange',this.filterDaterange);
    this.startDate = startDateString;
    this.endDate = endDateString;
    this.res()
  }

  reset(){
    this.tenor = '';
    this.agunan = '';
    this.plafon = '';
    this.kolektor = '';
    this.dateRange = '';
    this.filterDaterange = [];
    this.cabang = '';
    this.nn = '';
    this.startDate = '';
    this.endDate = '';
    this.userX = '';
    this.resetInput = !this.resetInput;
    this.ionicForm = this.formBuilder.group({
      name: ['']
    });
    this.res();
  }

  dateR(){
    console.log('dateRange',this.dateRange)
    this.tampilDateRange = false;
    this.tampilDateRange = true;
  }

   async detail(p: any) {
      const modal = await this.modalController.create({
        component: DetailReportPerformanceComponent,
        cssClass: 'wd-assignXX',
        componentProps: {
          datax: p,
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.role === 'confirm') {
        }else{
        }
      });
      return await modal.present();
    }

  res() {
    this.load = true;
    this.api.get('backoffice/reports/sales/performance?page='+this.page+'&limit=20&keyword='+this.nn+'&branch_id='+this.cabang+'&user_id='+this.userX+'&start_date='+this.startDate+'&end_date='+this.endDate)
      .subscribe((data) => {
        this.leadn = data;
        if (this.leadn.error == 0) {
          this.load = false;
            this.lnores = this.leadn.data.rows;
            this.summary = this.leadn.data.summary;
            this.pageInfo = this.leadn.data;
          // }
        } else {
          this.load = false;
          this.util.showToast(this.leadn.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  firstPage() {
    this.page = 1;
    this.res();
  }

  prevPage() {
    this.page = this.page -= 1;
    this.res();
  }

  nextPage() {
    this.page = this.page + 1;
    this.res();
  }

  lastPage() {
    this.page = this.pageInfo.total_pages;
    this.res();
  }


}
